import { Property, Type } from '@dipscope/type-manager';
import { tileMapConfig } from '../ccson/ccsonGameConfigLoader';
import 'reflect-metadata';
import KTile from './KTile';

@Type({
  injectable: true,
  discriminant: 'KTileSegment'
})
class KTileSegment {
  @Property()
  isRandom: boolean;
  @Property([KTile])
  tiles: KTile[];
}

export default KTileSegment;
